import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProductService } from 'src/app/services/product.service';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/services/alert.service';



@Component({
  selector: 'app-productinfopopup',
  templateUrl: './productinfopopup.component.html',
  styleUrls: ['./productinfopopup.component.scss']
})
export class ProductinfopopupComponent implements OnInit {
  showNotes: boolean = true;
  form: FormGroup;
  id: any;
  dropdownSettings: any = {};
  clarificationList: any[] = [];
  clarificationListCopy: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private _location: Location,
    private alertService: AlertService,


    public dialogRef: MatDialogRef<ProductinfopopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,

    public addServiceDialog: MatDialog,
    private navigationService: NavigationService,
  ) { this.id = this.dataRecievedToEdit.id }

  ngOnInit(): void {
    this.initializeValidators();
    this.get(true);

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };

  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      clarificationType: ['', Validators.required],
      remarks: ['', Validators.required]
    })
  }

  next() {
    this.dialogRef.close();

  }

  get(refresh: boolean) {
    this.clarificationList = [];
    this.clarificationListCopy = [];
    this.productService.getProductEdit(refresh).subscribe(result => {
      if (result) {
        this.clarificationList = result;
        // if (this.dataRecievedToEdit.type == 1) {
        //   this.clarificationListCopy = result.filter((i) => i.key == 1);
        //   this.form.controls['clarificationType'].setValue([this.clarificationListCopy[0]]);
        // } else {
          this.clarificationListCopy = result;
        // }
      }
    });
  }

  goToAction() {
    if (this.form.valid) {
      const clarificationTypeList = [];
      const selectedClarificationType = this.form.get('clarificationType').value;
      if (selectedClarificationType && selectedClarificationType.length > 0) {
        selectedClarificationType.forEach(element => {
          clarificationTypeList.push(element.key);
        });
      }
      var data = {
        id: 0,
        dbtProductInfoId: this.id,
        remarks: this.form.value.remarks,
        productEditType: JSON.stringify(clarificationTypeList),
        financialYearId: this.dataRecievedToEdit.financialYearId
      }
      this.productService.productClarificationSave(data).subscribe(res => {
        if (res) {
          this.alertService.success('Saved Successfully');

          this.dialogRef.close();
          this._location.back();

        }
      });
    }
    else {
      this.validateFormControl();
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }
}
